import { useDocumentInboxGate } from '@/app-shell/flags/integrations-flags';
import { useMobilePanel } from '@/app-shell/layout/Navigation/mobile';
import { NavItem } from '@/app-shell/layout/Navigation/sidebar/nav-item';
import { setSidebarOpenTab } from '@/atoms/persistedPreferencesAtoms';
import { Inbox } from 'lucide-react';
import { useCallback, useTransition } from 'react';
import { useIntl } from 'react-intl';

export const InboxNavItem = () => {
  const intl = useIntl();
  const [, startTransition] = useTransition();
  const { dismissMobileSidebar } = useMobilePanel();
  const gate = useDocumentInboxGate();

  const onClick = useCallback(() => {
    startTransition(() => {
      setSidebarOpenTab(undefined);
    });
    dismissMobileSidebar();
  }, [dismissMobileSidebar, startTransition]);

  if (gate !== 'on') {
    return null;
  }

  return (
    <NavItem
      label={intl.formatMessage({
        defaultMessage: 'Inbox',
        id: 'VCMKbtL+3b',
      })}
      icon={<Inbox />}
      href="/inbox"
      onClick={onClick}
      testId="sidebar-link-inbox"
    />
  );
};
